export default __webpack_public_path__ + "static/media/i37.6ceb1bd2.jpeg";